var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 18.8 19.1",
    style: {
      enableBackground: "new 0 0 18.8 19.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.82-0.03h-5.8c-0.49,0.07-0.92,0.49-0.92,1.06v0.14c0.07,0.49,0.42,0.85,0.99,0.85h3.25L7.78,9.58L7.71,9.65 C7.42,10.08,7.42,10.64,7.78,11c0.42,0.42,0.99,0.42,1.41,0l7.57-7.57v3.25v0.14c0.07,0.49,0.42,0.85,0.99,0.85 c0.57,0,0.99-0.42,0.99-0.99V1.03l0.07-0.21C18.74,0.32,18.38-0.03,17.82-0.03z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.98,11.99h-0.14c-0.49,0.07-0.85,0.42-0.85,0.99v4.1H1.98L2.12,4.07h2.83h0.14C5.59,4,5.94,3.64,5.94,3.08 S5.52,2.09,4.95,2.09h-4.1C0.35,2.16,0,2.65,0,3.08v14.99v0.14c0.07,0.49,0.42,0.85,0.99,0.85h14.99h0.14 c0.49-0.07,0.85-0.42,0.85-0.99v-5.09v-0.14C16.9,12.34,16.55,11.99,15.98,11.99z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.d22ead8c99e5f3f0171e046640235b9e.svg";
export { ForwardRef as ReactComponent };